import { styled } from '@mui/material/styles';

const Wrapper = styled('div')<{ width: number; height: number }>`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  position: relative;
`;

export default Wrapper;
